import React from "react";
import { cn } from "@/lib/utils";

interface ReadMoreButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "minimal";
  size?: "sm" | "md" | "lg";
  children?: React.ReactNode;
  showArrow?: boolean;
}

export function ReadMoreButton({ 
  variant = "default", 
  size = "md", 
  className, 
  children = "Read more",
  showArrow = true,
  ...props 
}: ReadMoreButtonProps) {
  const baseStyles = "relative inline-flex items-center justify-center font-medium transition-all duration-300 ease-in-out hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    default: "text-black font-bold border-b border-ss-green hover:border-ss-green transition-colors",
    minimal: "text-gray-600 hover:text-ss-blue font-medium"
  };
  
  const sizes = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };
  
  return (
    <button
      className={cn(
        baseStyles,
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      <span>{children}</span>
    </button>
  );
}
